import Dinero from "dinero.js";

interface IMoney {
  amount: string | number;
  currency: string;
}

interface ICurrencyOptions {
  style: string;
  currency: string;
  withCents: boolean;
}

class Money {
  protected amount: string | number | null;
  protected currency = "EUR";
  protected options: ICurrencyOptions;
  protected locale = "it";

  constructor(money: string | number) {
    let _money: IMoney;

    if (money === null || money === undefined) {
      this.amount = null;
      this.currency = "EUR";
      this.options = {
        style: "currency",
        currency: "EUR",
        withCents: false,
      };

      return;
    }

    switch (typeof money) {
      case "number":
        _money = { amount: money * 100, currency: "EUR" };
        break;
      case "string":
        _money = { amount: parseInt(money) * 100, currency: "EUR" };
        break;
      default:
        _money = money;
        break;
    }

    if (!_money) _money = { amount: 0, currency: "EUR" };

    this.amount = parseInt(_money.amount as string);
    this.options = {
      style: "currency",
      currency: _money.currency || "EUR",
      withCents: false,
    };
    this.locale = "it";
  }

  formatNull() {
    return "-";
  }

  format(noCurrency: boolean) {
    if (this.amount === null) return this.formatNull();

    const money = Dinero({
      amount: this.amount as number,
      currency: this.options.currency as Dinero.Currency,
    });

    let format = noCurrency ? "" : "$";

    format += this.options.withCents ? `0,0.00` : "0,0";

    const moneyFormat = money.setLocale(this.locale).toFormat(format);

    return moneyFormat;
  }

  formatNoCurrency() {
    return this.format(true);
  }
}

export default Money;
